import { z } from 'zod';

import { collectionItemArraySchema } from './collectionItem.schema';

export const collectionSchema = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string().optional(),
  collection_items: z.array(
    z.object({
      item_key: z.string(),
    })
  ),
  creator_id: z.string(),
  date_created: z.number().optional(),
  date_modified: z.number().optional(),
  is_public: z.boolean().optional(),
  site_language: z.string().optional(),
  isOptimistic: z.boolean().optional(),
  designation: z.string().optional(),
});

export const collectionWithMeta = z.object({
  collection_items: collectionItemArraySchema,
  meta: z.object({
    pageCount: z.number(),
    pageNumber: z.string(),
    pageSize: z.string(),
    totalResults: z.number(),
  }),
});
